<template>
  <div class="content">
    <el-tabs  @tab-click="handleClick">
      <el-tab-pane label="转套餐查询"  v-if="checkPermi(['package:manage:turn'])">
        <ztcPackage ref="ztcRef"></ztcPackage>
      </el-tab-pane>
      <el-tab-pane label="套餐作废查询"  v-if="checkPermi(['package:manage:cancellation'])">
        <zfPackage ref="zfRef"></zfPackage>
      </el-tab-pane>
      <el-tab-pane label="套餐续费查询"  v-if="checkPermi(['package:manage:renew'])">
        <tcxfPackage ref="tcxfRef"></tcxfPackage>
      </el-tab-pane>
      <el-tab-pane label="套餐操作"  v-if="checkPermi(['package:manage:operate'])">
        <el-form :model="ruleForm" ref="ruleForm"  :rules="rules" :inline="false">
          <el-form-item  prop="iccid">
            <el-input  placeholder="请输入ICCID" style="width:270px" v-model.trim="ruleForm.iccid"></el-input>
            <el-button type="primary" size="medium" @click="queryIccid()" style="margin-left: 15px;">查询</el-button>
          </el-form-item>
          <el-form-item prop="productOrder">
            <el-select v-model="ruleForm.productOrder" filterable clearable placeholder="请选择套餐" style="width:270px" @change="selectPackage">
              <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="orderNum">
            <el-input  placeholder="微信支付订单号" style="width:270px" v-model.trim="ruleForm.orderNum"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="submitForm()" style="margin-top: 30px;">下一步</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { cardProductQueryCardProduct } from "@/api/api.js"; //获取卡的套餐信息
import  ztcPackage  from "@/components/package/ztcPackage.vue"; //转套餐
import  zfPackage  from "@/components/package/zfPackage.vue"; //作废套餐
import  tcxfPackage  from "@/components/package/tcxfPackage.vue"; //套餐续费
export default {
  name:'packageManage',
  data() {
    return{
      // 申请退款
      ruleForm:{
        iccid:undefined,
        productOrder:undefined,
        orderNum:undefined
      },
      rules: {
        iccid: [
          { required: true, message: "请输入ICCID", trigger: "blur" },
        ],
        productOrder: [
          { required: true, message: "请选择套餐", trigger: "blur" }
        ],
        orderNum: [
          { required: true, message: "微信支付订单号不能为空", trigger: "blur" }
        ],
      },
      operator:[],
    }
  },
  components:{
    ztcPackage,
    zfPackage,
    tcxfPackage
  },
  methods: {
    handleClick(tab, event) {
      if(tab.label == "转套餐查询"){
        this.$refs.ztcRef.initData();
      }else if(tab.label == "套餐作废查询"){
        this.$refs.zfRef.initData();
      }else if(tab.label == "套餐续费查询"){
        this.$refs.tcxfRef.initData();
      }else{
        for(let i in this.ruleForm){
          this.ruleForm[i] = "";
        }
      }
    },
    // 查询iccid 的套餐
    queryIccid(){
      if(!this.ruleForm.iccid) return this.$message.error('请输入要查询的ICCID');
      let params = {
        iccid:this.ruleForm.iccid
      }
      cardProductQueryCardProduct(params).then(res=>{
        if(res.data.code == 200){
          this.operator = [];
          for(let i in this.ruleForm){
            this.ruleForm["productOrder"] = "";
            this.ruleForm["orderNum"] = "";
          }
          this.$notify({
            title: '成功',
            message: '查询套餐成功',
            type: 'success'
          });
          res.data.data.map(item=>{
            this.operator.push({
              value:item.orderNum,
              label:item.productName
            })
          })
        }
      })
    },
    selectPackage(){
      this.ruleForm.orderNum = this.ruleForm.productOrder;
    },
    submitForm(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // this.$router.push(`/package/operation/` + this.ruleForm.orderNum);
          this.$router.push({path:"/package/operation",query:{orderNum: this.ruleForm.orderNum}});
        }
      });
      
    }
  },
  mounted() {

  },
  created() {
    
  }
};
</script>
<style scoped lang="less">

</style>


